import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import constants from '@/app-configs/constants'
import users from './users'
import settings from './settings'
import apitokens from './apitokens'
import apisettings from './apisettings'
import adminsettings from './adminsetting'
import usersettings from './usersetting'
import cases from './cases'
import clients from './clients'
// import partner from './partner'
import partners from './partners'
import debtors from './debtor'
import eventlogs from './eventlogs'
import orders from './orders'
import letters from './letters'
import templates from './templates'
import statementgroups from './statementgroups'
import filecategories from './filecategories'
import currencysettings from './currencysettings'
import bcapisettings from './bcapisettings'
import customfields from './customfields'
import contacts from './contacts'
import aksdebtors from './aksdebtors'
import dataexport from './dataexport'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'DEBTIA_HOME',
        breadcrumb: [
          {
            text: 'DEBTIA_HOME',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/processes',
      name: 'processes',
      component: () => import('@/views/processes/List.vue'),
      meta: {
        pageTitle: 'DEBTIA_PROCESSES',
        breadcrumb: [
          {
            text: 'DEBTIA_PROCESSES',
            active: true,
          },
        ],
        action: constants.action.permissionProcessList,
        resource: constants.resource.process,
      },
    },
    {
      path: '/process/copy/:id',
      name: 'process-copy-view',
      component: () => import('@/views/processes/copyprocess/ViewProcess.vue'),
      meta: {
        action: constants.action.permissionProcessEdit,
        resource: constants.resource.process,
      },
    },
    {
      path: '/process/view/:id',
      name: 'process-view',
      component: () => import('@/views/processes/ViewProcess.vue'),
      meta: {
        action: constants.action.permissionProcessEdit,
        resource: constants.resource.process,
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
        resource: 'MyRule',
        action: 'rule',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/newsletter/unsubscribe',
      name: 'newsletter-unsubscription',
      component: () => import('@/views/Subscription.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/reset-password/:token',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/tasklist-item-details/:id',
      name: 'tasklist-item-details',
      component: () => import('@/views/taskList/Itemdetails.vue'),
      meta: {
        pageTitle: 'DEBTIA_TASKLIST_ITEM_DETAILS',
        breadcrumb: [
          {
            text: 'DEBTIA_TASKLIST_ITEM_DETAILS',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/402/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        pageTitle: 'DEBTIA_PROFILE',
        breadcrumb: [
          {
            text: 'DEBTIA_PROFILE',
            active: true,
          },
        ],
        resource: 'Auth',
        action: 'read',
      },
    },
    ...users,
    ...cases,
    ...settings,
    ...apitokens,
    ...apisettings,
    ...clients,
    // ...partner,
    ...debtors,
    ...partners,
    ...customfields,
    ...eventlogs,
    ...orders,
    ...adminsettings,
    ...usersettings,
    ...letters,
    ...templates,
    ...filecategories,
    ...statementgroups,
    ...currencysettings,
    ...bcapisettings,
    ...contacts,
    ...aksdebtors,
    ...dataexport,
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })
    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  // if (!isLoggedIn) console.log('isLoggedIn', to)
  // Redirect if logged in
  if (to.name === 'translations') {
    // eslint-disable-next-line no-param-reassign
    to.meta.navActiveLink = to.params.lang
  }
  if (isLoggedIn) {
    const role = JSON.parse(localStorage.getItem('userData')).role[0]
    if (to.meta.companyOnly && role === 'super-admin') return next({ name: 'misc-not-authorized' })
  }
  // console.log('changing', this.$route.params)
  return next()
})

export default router
